/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Unavailable

1 = Document

2 = Photo

3 = DocumentsAndPhotos

4 = Video

6 = PhotosAndVideos

7 = All


 */
export type MediaTypes = (typeof MediaTypes)[keyof typeof MediaTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaTypes = {
  Unavailable: 0,
  Document: 1,
  Photo: 2,
  DocumentsAndPhotos: 3,
  Video: 4,
  PhotosAndVideos: 6,
  All: 7,
} as const;
